import React, {useState, useEffect, useContext, useRef} from 'react';
import { InfoWindowHook } from './InfoWindowHook';
import { useSetRoute } from '_context/commonHooks';

const PoiInfoWindow = (props) => {
    const [poiName, setPoiName] = useState('')
    const [category, setCategory] = useState('')
    const [phone, setPhone] = useState('')
    const [homePage, setHomePage] = useState('')
    const [photoURL, setPhotoURL] = useState('')
    const [roadAddress, setRoadAddress] = useState('')
    const [landAddress, setLandAddress] = useState('')
    const {setDisplay, location} = InfoWindowHook(props, 22, 190, 302, 170, 'PoiInfoWindow'); 
    const [setRoute] = useSetRoute()

    useEffect(() => {
        if(props.marker){
            let attr = props.marker.attribute
            setPoiName(attr.name + (attr.branch?' '+attr.branch:'') + (attr.subName?' '+attr.subName:''))
            setCategory(attr.category.masterName)
            attr.phones && attr.phones.normal ? setPhone(phoneDisplay(attr.phones.normal)) : setPhone('');
            attr.phones && attr.phones.representation ? setPhone(phoneDisplay(attr.phones.representation)) : setPhone('')
            attr.extension && attr.extension.homepageURL ? setHomePage(attr.extension.homepageURL) : setHomePage('')
            setRoadAddress(attr.address.siDo + " " + attr.address.siGunGu + " " + attr.address.street + " " + attr.address.streetNumber)
            setLandAddress(attr.address.eupMyeonDong + " " + attr.address.houseNumber)
            attr.extension && attr.extension.photoURL ? setPhotoURL(attr.extension.photoURL) : setPhotoURL('')
        }
    }, [props.marker])

    const setWinRoute=(target,keyword,point, mode)=>{
        setRoute(target,keyword,point,mode); 
    }

    const phoneDisplay = val => {
        if(Array.isArray(val)){
            let display = ''
            val.some(ele=>{
                display += (ele + ', ')
                return false
            })
            return display.substring(0, display.length-3)
        }else{
            return val
        }
    }

    return (
        <div className="lyBox innerMap botLeft" style={{left:location.x, top:location.y, display:location.display, opacity:location.opacity}}>
            <div className="title">
                {/* <button className="btnsSch ic_bookmark" title="즐겨찾기">즐겨찾기</button> */}
                {poiName}
            </div>
            <div className="info">
                <span className="kind">{category}</span>
                <span className="tel">{phone}</span>
                <a href={homePage} target="_blank" className="web" style={{display:(homePage==''?'none':'inline')}}>홈페이지</a>
            </div>
            <div className="address">{roadAddress}</div>
            <div className="address">
                <span className="jibun">지번</span>
                {landAddress}
            </div>
            <div className="departureArrival">
                <button className="ic_start" onClick={()=>setWinRoute("start",poiName,props.marker.attribute.point)}><span className="btnsSch"></span><span>출발</span></button>
                <button className="ic_waypoint" onClick={()=>setWinRoute("wayPoints",poiName,props.marker.attribute.point, 'add')}><span className="btnsSch"></span><span>경유지</span></button>
                <button className="ic_arrival" onClick={()=>setWinRoute("end",poiName,props.marker.attribute.point)}><span className="btnsSch"></span><span>도착</span></button>
            </div>
            <img src={photoURL} alt="" className="photo"></img>
            <button className="btnsSch btnClose" onClick={(e) => {setDisplay('none'); props.close(e)}}>닫기</button>
	    </div>
    );
}

export default PoiInfoWindow